import { ProjectActionType, IProjectState, ProjectAction } from "../types/projectDataKeywords"

const initialState: IProjectState = {
  projectDataKeywords: [],
  loading: false,
  error: null,
}

export const projectDataKeywordsReducer = (
  state: IProjectState = initialState,
  action: ProjectAction
): IProjectState => {
  switch (action.type) {
    case ProjectActionType.FETCH_PROJECT_DATA_KEYWORDS:
      return { ...state, loading: true }
    case ProjectActionType.FETCH_PROJECT_DATA_KEYWORDS_SUCCESS:
      return { ...state, projectDataKeywords: action.payload, loading: false }
    case ProjectActionType.FETCH_PROJECT_DATA_KEYWORDS_ERROR:
      return { ...state, error: action.payload, loading: false }
    default:
      const exhaustiveCheck: never = action
      return state
  }
}

export default projectDataKeywordsReducer
